import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Skeleton,
  Button,
} from '@mui/material';
import React from 'react';
import {useGetTradrMembersQuery} from 'api';
import AddIcon from '@mui/icons-material/Add';
import TradrMemberDeleteIconButton from './TradrMemberDeleteIconButton';
import CreateTradrMemberModal from './TradrMemberCreateModal';

const totalColumns = 4;

function TradrMembersTable() {
  const {data, isLoading, isError, isSuccess} = useGetTradrMembersQuery();
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      <CreateTradrMemberModal
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      />
      <TableContainer component={Paper}>
        <Table sx={{minWidth: 650}} aria-label="TradrMember Table">
          <TableHead>
            <TableRow>
              <TableCell colSpan={totalColumns - 1}>Tradr Members</TableCell>
              <TableCell align="right">
                <Button
                  onClick={() => {
                    setIsOpen(true);
                  }}
                  disableElevation
                  variant="contained"
                  endIcon={<AddIcon />}
                >
                  Add
                </Button>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell align="center">Email</TableCell>
              <TableCell align="center">Role</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isSuccess &&
              Boolean(data?.length) &&
              data.map(row => (
                <TableRow key={row._id} sx={{'&:last-child td, &:last-child th': {border: 0}}}>
                  <TableCell component="th" scope="row">
                    {row._id}
                  </TableCell>
                  <TableCell align="center">{row.user.email}</TableCell>
                  <TableCell align="center">{row.role.name}</TableCell>
                  <TableCell align="center">
                    {/* <TradrMemberEditIconButton TradrMember={row} /> */}
                    <TradrMemberDeleteIconButton TradrMemberId={row._id} />
                  </TableCell>
                </TableRow>
              ))}
            {Boolean(isSuccess && !data?.length) && (
              <TableRow>
                <TableCell colSpan={totalColumns}>No Member found</TableCell>
              </TableRow>
            )}
            {isError && (
              <TableRow>
                <TableCell colSpan={totalColumns}>
                  <Typography color="error">Failed to fetch Members.</Typography>
                </TableCell>
              </TableRow>
            )}
            {isLoading && (
              <TableRow>
                {Array.from(Array(totalColumns).keys()).map(key => (
                  <TableCell key={key}>
                    <Skeleton variant="text" />
                  </TableCell>
                ))}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default TradrMembersTable;
